<div class="madar--v2">
  <button
    mat-flat-button color="primary"
    (click)="onAddNewButtonClicked()"
    >
    <app-icon name="add_circle" type="MaterialDesign" size="xs" class="mr-1"></app-icon>
   <span class="small">{{ label }}</span>
  </button>
</div>
